// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

/* Store Custom Code - Start */
const colors: Styleguide["colors"] = {
    primary: {
        main: "#1F4D6B", // Primary -> Main
        contrast: "#ffffff", // None, look at primary button text color
        light: "#44637F", // Primary -> Light
        dark: "#14364A", // Primary -> Dark
    },
    secondary: {
        main: "#2D6A67", // Secondary -> Main
        contrast: "#ffffff", // None, look at secondary button text color
        light: "#437C7C", // Secondary -> Light
        dark: "#1A3F3D", // Secondary -> Dark
    },
    tertiary: {
        main: "#49A3B2", // Tertiary -> Main
        contrast: "#ffffff", // None, look at tertiary button text color
        light: "#8CCBD7", // Tertiary -> Light
        dark: "#245E6A", // Tertiary -> Dark
    },
    common: {
        border: "#D9D9D9", // Border -> Border
        borderLight: "#F6F6F6", // Gray Shades -> Light
        borderDark: "#52535A", // Gray Shades -> Main
        accent: "#F6F6F6", // Gray Shades -> Light
        accentContrast: "#2a2b31", // Black
        accentContrastLight: "#52535A", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        backgroundContrast: "#2a2b31", // Black
        disabled: "#F6F6F6", // Gray Shades -> Light
        disabledDark: "#D9D9D9", // Gray Shades -> Mid
    },
    text: {
        main: "#143042", // Text Color -> Main
        accent: "#1F4D6B", // Text Color -> Accent
        disabled: "#7E7E7E", // Text Color -> Semi
        link: "#1F4D6B", // Primary -> Main
        linkHover: "#44637F", // Primary -> Light
        linkAlt: "#2D6A67", // Secondary -> Main
        linkAltHover: "#437C7C", // Secondary -> Light
        input: "#143042", // Text Color -> Main
    },
    success: {
        main: "#0f7b5c", // Alerts/Contrast -> Success
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#e4f5f4", // Alerts/Light -> Success
    },
    warning: {
        main: "#a45e28", // Alerts/Contrast -> Warning
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#fff5e9", // Alerts/Light -> Warning
    },
    danger: {
        main: "#cb2045", // Alerts/Contrast -> Error
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#f5e8ea", // Alerts/Light -> Error
    },
    info: {
        main: "#1676b1", // Alerts/Contrast -> Info
        contrast: "#ffffff", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#f0faff", // Alerts/Light -> Info
    },
    neutral: {
        main: "#7E7E7E", // Text Color -> Semi
        contrast: "#ffffff", // None
        light: "#F6F6F6", // Gray Shades -> Light
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#1F4D6B", // Primary -> Main
        hover: "#14364A", // Primary -> Dark
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#1F4D6B", // Text Color -> Accent
        disabled: "#D9D9D9", // Gray Shades -> Mid
    },
    button: {
        disabled: {
            main: "#F6F6F6", // Gray Shades -> Light
            contrast: "#7E7E7E", // Text Color -> Semi
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#143042", // Text Color -> Main
        hover: "#14364A", // Primary -> Dark
        accent: "#1F4D6B", // Primary -> Main
        accentHover: "#14364A", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#ffffff", // None, look at main navigation background color
            contrast: "#143042", // Text Color -> Main
            hover: "#1F4D6B", // Primary -> Main
            underline: "#1F4D6B", // Primary -> Main
            accent: "#1F4D6B", // Primary -> Main
            accentContrast: "#ffffff", // None, should match "primary.contrast"
            accentHover: "#1F4D6B", // Primary -> Main
            separator: "#D9D9D9", // Border -> Border
            border: "#D9D9D9", // Border -> Border
        },
        secondaryNavigation: {
            main: "#1F4D6B", // Primary -> Dark
            contrast: "#ffffff", // None, should match "primary.contrast"
            hover: "#ffffff", // None, should match "primary.contrast"
        },
        megaMenuWithTabs: {
            tabsBackground: "#F6F6F6", // Gray Shades -> Light
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#F6F6F6", // Gray Shades -> Light
        contrast: "#143042", // Text Color -> Main
        alt: "#1F4D6B", // Primary -> Main
        altContrast: "#ffffff", // None, should match "primary.contrast"
    },
    swatch: {
        main: "#D9D9D9", // Border -> Border
        contrast: "#143042", // Text Color -> Main
        hover: "#1F4D6B", // Primary -> Main
        selected: "#1F4D6B", // Primary -> Main
        selectedHover: "#14364A", // Primary -> Dark
    },
};
/* Store Custom Code - End */

export default colors;
